'use client'

import Link from 'next/link'
import Header from '@/components/header'
import Footer from '@/components/footer'
import { Button } from '@/components/ui/button'
import { motion } from 'framer-motion'

export default function NotFound() {
  return (
    <>
      <Header />
      <div className="flex flex-col min-h-screen items-center justify-center bg-gradient-to-b from-gray-900 to-blue-900 text-white p-4">
        <motion.div 
          initial={{ opacity: 0, scale: 0.8, rotate: -10 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 0.5, type: 'spring', stiffness: 100 }}
          className="text-center space-y-8"
        >
          <motion.div 
            animate={{ y: [0, -10, 0] }}
            transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
            className="text-8xl mb-8"
          >
            👽
          </motion.div>
          
          <h1 className="text-6xl font-bold text-cyan-300 drop-shadow-lg">
            Error 404
          </h1>
          <p className="text-2xl text-blue-200 max-w-md mx-auto">
            Oops! Looks like this page got lost in the cosmic void. Maybe it was abducted by aliens?
          </p>
          
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <Link href="/">
              <Button 
                variant="outline" 
                className="border-2 border-cyan-300 text-cyan-300 hover:bg-cyan-300/20 hover:text-cyan-200 px-8 py-3 text-lg rounded-full font-semibold transition-colors duration-300"
              >
                Return to Home Base
              </Button>
            </Link>
          </motion.div>
          
          {/* Optional: Add some floating space elements */}
          <div className="absolute top-1/4 left-1/4 w-8 h-8 bg-yellow-300 rounded-full opacity-50 animate-pulse"></div>
          <div className="absolute top-1/3 right-1/4 w-6 h-6 bg-red-500 rounded-full opacity-50 animate-ping"></div>
          <div className="absolute bottom-1/4 left-1/3 w-10 h-10 bg-purple-400 rounded-full opacity-30 animate-pulse delay-500"></div>
          <div className="absolute bottom-1/3 right-1/3 w-4 h-4 bg-green-400 rounded-full opacity-60 animate-ping delay-300"></div>
        </motion.div>
      </div>
      <Footer />
    </>
  )
} 